/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    Coordinate2d, Positionable,
    SimpleReelModelDelegate, SimpleReelModelState,
    SimpleReelModelSymbolData, SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {TheCageStatics} from "../config/TheCageStatics";
import {LayersSet} from "./LayersSet";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FreeSpinsMatrixAvalancheModel} from "./freespins/FreeSpinsMatrixAvalancheModel";
import {TheCageSymbol, TheCageSymbolStates} from "./TheCageSymbol";
import {ScatterSymbol} from "./ScatterSymbol";
import {XBombSymbol} from "./XBombSymbol";
import {MathUtils} from "../utils/MathUtils";
import {TheCage} from "../TheCage";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {FreespinsOpponentDelegate} from "../view/parts/FreespinsOpponent";
import {FreespinsFeatures} from "../view/parts/FreespinsFeatures";
import {FreespinsOpponentLifeCounterDelegate, FreespinsPlayerLifeCounterDelegate} from "../view/parts/FreespinsLifeCounter";
import {GloveSymbol} from "./freespins/GloveSymbol";
import {TheCageTransitionScreenView} from "../view/TheCageTransitionScreenView";


export class TheCageFreesSpinReelsView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate {
    public layers:LayersSet;

    //private _frameBackground:PIXI.spine.Spine;
    private _frameGrid:PIXI.Sprite;
    //public frameBlackOut:PIXI.Sprite;
    public startPositions:Coordinate2d[][];
    public avalancheMatrixModel:FreeSpinsMatrixAvalancheModel;
    public opponent:FreespinsOpponentDelegate;
    public features:FreespinsFeatures;
    public opponentCounter: FreespinsOpponentLifeCounterDelegate;
    public playerCounter: FreespinsPlayerLifeCounterDelegate;

    constructor() {
        super();
        this.name = "TheCageFreesSpinReelsView";
        this.init();
    }

    private init() {
        this.layers = new LayersSet();

        this._frameGrid = new PIXI.Sprite(TheCage.assetLoader.getTextures(TheCageGameAssets.FS_REEL_FRAME)[0]);
        this._frameGrid.anchor.set(0.5,0.5);
        this._frameGrid.position.set(360, 360);
        this._frameGrid.name = "_frameGrid";
        this.opponent = new FreespinsOpponentDelegate();
        this.features = new FreespinsFeatures();
        this.opponentCounter = new FreespinsOpponentLifeCounterDelegate();
        this.playerCounter = new FreespinsPlayerLifeCounterDelegate();

        const columns = 9;
        this.avalancheMatrixModel = new FreeSpinsMatrixAvalancheModel(9, this, true);

        this.startPositions = [];
        for (let i:number = 0; i < 9; i++) {
            if (i % 2 != 0) {
                this.startPositions.push([
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 0 + TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 1 + TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 2 + TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                ]);
            } else {
                this.startPositions.push([
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 0.5 + +TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 1.5+ +TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET_FS + TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN,
                        y:TheCageStatics.REEL_Y_OFFSET_FS * 2.5 + +TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN
                    },
                ]);
            }
        }
        this.startPositions[3].splice(0, 1);
        this.startPositions[4].splice(0, 1);
        this.startPositions[5].splice(0, 1);

        const mask = this.createMask();
        this.layers.maskedNormal.addChild(mask);
        this.layers.maskedNormal.mask = mask;

        this.addChild(this.opponent);
        this.addChild(this._frameGrid);

        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.layers.maskedHighlight);
        this.addChild(this.layers.win);
        this.addChild(this.layers.winOver);
        this.addChild(this.features);
        this.addChild(this.opponentCounter);
        this.addChild(this.playerCounter);

        this.addChild(this.layers.overlay);

        this.position.set(360,360);
        this.pivot.set(360,360);
        this.scale.set(0.85, 0.85);

        this.onResize();
        this.hide(0);
    }

    private createMask():PIXI.Graphics {
        const normalPolygon:PIXI.Point[] = [
            // left side
            new PIXI.Point(0, 6),
            new PIXI.Point(1, 5),
            new PIXI.Point(0, 4),
            new PIXI.Point(1, 3),
            new PIXI.Point(0, 2),
            new PIXI.Point(2, 0),

            // top side
            new PIXI.Point(5, 3),
            new PIXI.Point(8, 0),

            // right side
            new PIXI.Point(10, 2),
            new PIXI.Point(9, 3),
            new PIXI.Point(10, 4),
            new PIXI.Point(9, 5),
            new PIXI.Point(10, 6),
            new PIXI.Point(9, 7),

            // bottom side
            new PIXI.Point(8, 6),
            new PIXI.Point(7, 7),
            new PIXI.Point(6, 6),
            new PIXI.Point(5, 7),
            new PIXI.Point(4, 6),
            new PIXI.Point(3, 7),
            new PIXI.Point(2, 6),
            new PIXI.Point(1, 7),
        ];

        for (let i:number = 0; i < normalPolygon.length; i++) {
            normalPolygon[i] = MathUtils.multiplyPoints(normalPolygon[i], new PIXI.Point(TheCageStatics.STEP_WIDTH, TheCageStatics.STEP_HEIGHT));
            normalPolygon[i].x += TheCageStatics.REEL_AREA_X_OFFSET_FREESPIN;
            normalPolygon[i].y += TheCageStatics.REEL_AREA_Y_OFFSET_FREESPIN;

            normalPolygon[i].x -= TheCageStatics.STEP_WIDTH;
            normalPolygon[i].y -= TheCageStatics.STEP_HEIGHT;
        }

        const mask = new PIXI.Graphics();
        mask.beginFill(0xffffff, 0.3);
        mask.drawPolygon(normalPolygon);
        mask.endFill();

        return mask;
    }

    onResize():void {
        this.playerCounter.setLandscapeMode(NolimitApplication.isLandscape);
        this.opponentCounter.setLandscapeMode(NolimitApplication.isLandscape);
    }

    public getExplodeShake():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=>{this.position.set(0,0)});
        tl.add(gsap.to(this.position, {
            duration:0.3,
            x:"-=3",
            ease:TheCageStatics.explodeWiggle
        }));
        tl.add(gsap.to(this.position, {
            duration:0.4,
            y:"-=5",
            ease:TheCageStatics.explodeWiggle
        }),0);
        tl.add(()=>{
            this.position.set(0,0);
        })

        return tl;
    }

    hideForLevelUp(duration: number = 0.1) {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this.opponent, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.maskedNormal, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.maskedOver, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.maskedHighlight, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.win, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.winOver, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.overlay, {duration:duration, alpha:0, ease:"none"}),
            gsap.to(this.layers.maskedNormal, {duration:duration, alpha:0, ease:"none"}),
        ], '<');
        return tl;
    }

    showForLevelUp(duration: number = 0.1) {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this.opponent, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.maskedNormal, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.maskedOver, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.maskedHighlight, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.win, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.winOver, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.overlay, {duration:duration, alpha:1, ease:"none"}),
            gsap.to(this.layers.maskedNormal, {duration:duration, alpha:1, ease:"none"}),
        ], '<');
        return tl;
    }

    public giveIntroFeaturesTo(target:TheCageTransitionScreenView):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            target.features = this.features;
            this.removeChild(this.features);
            target.featureContainer.addChild(this.features);

            target.playerCounter = this.playerCounter;
            this.removeChild(this.playerCounter);
            target.featureContainer.addChild(this.playerCounter);

            target.opponentCounter = this.opponentCounter
            this.removeChild(this.opponentCounter);
            target.featureContainer.addChild(this.opponentCounter);
        })
        return tl;
    }

    hide(duration:number = 0.1) {
        const tl = gsap.timeline();

        tl.add(gsap.to(this, {duration:duration, alpha:0, ease:"none"}));
        tl.add(() => {
            this.visible = false;
            //this._frameBackground.state.setEmptyAnimation(0, 0);
            //this._frameGrid.state.setEmptyAnimation(0, 0);
            //this._frameGrid.state.setEmptyAnimation(1, 0);
            //this._frameGrid.state.setEmptyAnimation(2, 0);
            //this._frameGrid.state.setEmptyAnimation(3, 0);
            //this._frameGrid.state.setEmptyAnimation(4, 0);
        });
        return tl;
    }

    show(duration:number = 0.1):gsap.core.Timeline {
        this.onResize();
        const tl = gsap.timeline();
        tl.add(() => {
            //this._frameBackground.state.setAnimation(0, "base", true);
            //this._frameGrid.state.setAnimation(0, "frame", false);
            this.visible = true;
            this.opponent.alpha = 0;
            this.opponent.alpha = 0;
            this.layers.maskedNormal.alpha = 0;
            this.layers.maskedOver.alpha = 0;
            this.layers.maskedHighlight.alpha = 0;
            this.layers.win.alpha = 0;
            this.layers.winOver.alpha = 0;
            this.layers.overlay.alpha = 0;
            this.layers.maskedNormal.alpha = 0;
        });
        tl.add(gsap.to(this, {duration:duration, alpha:1, ease:"none"}));
        return tl;
    }

    restore() {
        return gsap.timeline().add(() => {
            this.onResize();
            this.visible = true;
            this.alpha = 1;
        });
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, symbolPosition:SimpleReelModelSymbolPosition):Positionable {
        const symbolState:TheCageSymbolStates = state == SimpleReelModelState.SPIN ? TheCageSymbolStates.SPIN : TheCageSymbolStates.NORMAL;

        let symbol:TheCageSymbol;
        if (TheCageStatics.isScatterSymbol(symbolName)) {
            symbol = new ScatterSymbol(symbolName, symbolState, this);
        }
        else if (symbolName == "WB") {
            symbol = new XBombSymbol(symbolName, symbolState, this);
        }
        else if (symbolName == "BN") {
            symbol = new GloveSymbol(symbolName, symbolState, this);
        }
        else {
            symbol = new TheCageSymbol(symbolName, symbolState, this);
        }


        if(symbolName == "BLANK"){
            symbol.getStateAnimation(TheCageSymbolStates.REMOVE);
        }


        if (state == SimpleReelModelState.FILL_UP) {
            this.layers.maskedNormal.addChildAt(symbol, 0);
        } else {
            this.layers.maskedNormal.addChild(symbol);
        }
        return symbol;
    }

    removeSymbol(symbolData:SimpleReelModelSymbolData):void {
        (<TheCageSymbol>symbolData.positionable).destroy();
    }

    getVisibleSymbolDataAt(column:number, row:number):SimpleReelModelSymbolData {
        const visibleSymbols = this.avalancheMatrixModel.getAllVisibleSymbols();
        return visibleSymbols[column][row];
    }

    public transformSymbolAt(column:number, row:number, toSymbol:string):{oldSymbol:SimpleReelModelSymbolData, newSymbol:SimpleReelModelSymbolData} {
        const data = this.avalancheMatrixModel.swapSymbol(toSymbol, column, row);
        this.layers.maskedNormal.addChildAt(<TheCageSymbol>data.newSymbol.positionable, this.layers.maskedNormal.getChildIndex(<TheCageSymbol>data.oldSymbol.positionable));
        return data;
    }
}